export const ALL = 'all'

export const ACTIVE = 'active'

export const INACTIVE = 'inactive'

export default [ALL, ACTIVE, INACTIVE]
